export const REALDB_CONSTANT = {
    "Sellersdata": "/signature_2025_jwcc_sep/Sellersdata",
    "SellerBaseData": "/signature_2025_jwcc_sep/SellerBaseData"
}